import React, { useState } from "react";
import LeftArea from "./LeftArea";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Input from "./InputYeni";
import Button from "./Button";
import Adim from "./Adim";
import { saveUserData } from "../../redux/actions";

const Kayit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);
  const [formError, setFormError] = useState(null);

  // İsim formatlamak için fonksiyon
  const capitalizeName = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError(null);

    const formData = new FormData(e.target);
    const userData = Object.fromEntries(formData.entries());
    Object.keys(userData).forEach((key) => {
      if (userData[key] === "on") {
        userData[key] = true;
      } else if (userData[key] === "") {
        userData[key] = false;
      }
    });

    // İsim ve soyisim formatlaması
    if (userData.name) {
      userData.name = capitalizeName(userData.name);
    }

    // Email'i localStorage'a kaydet
    localStorage.setItem("pendingEmail", userData.email);
    try {
      const response = await dispatch(saveUserData(userData)).unwrap();
      navigate("/onay_kodu", {
        state: {
          email: userData.email,
          name: userData.name,
        },
      });
    } catch (err) {
      setFormError(
        err?.message || "Kayıt işlemi başarısız. Lütfen tekrar deneyin."
      );
    }
  };
  const welcome = true;
  return (
    <div className="containerMain grid items-start grid-cols-1 xl:grid-cols-2 gap-20 xl:gap-2 justify-between mx-auto place-items-center h-auto my-28">
      <LeftArea welcome={welcome} />
      <div className="rightArea">
        <form className="form-container space-y-4" onSubmit={handleSubmit}>
          <Input page="kayit" />

          <Button loading={loading} />
          {(error || formError) && (
            <p className="text-red-500 mt-2">{error || formError}</p>
          )}
          <Adim />
        </form>
      </div>
    </div>
  );
};

export default Kayit;
